import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [devLink, setDevLink] = useState(null);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_reset_link) setDevLink(data.dev_reset_link);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <ShieldCheck className="w-7 h-7 text-petroleum" strokeWidth={1.5} />
          <span className="font-heading text-xl font-bold text-charcoal">CERH</span>
        </Link>
        <div className="bg-card border border-petroleum/10 rounded-2xl p-8 shadow-[0_8px_30px_rgba(14,79,79,0.08)]">
          <h1 className="font-heading text-2xl font-bold text-charcoal mb-1">Recuperar contraseña</h1>
          {sent ? (
            <div className="mt-4 text-sm text-charcoal/70" data-testid="forgot-password-sent-message">
              <p>Si la cuenta existe, se envió un enlace de recuperación.</p>
              {devLink && <a href={devLink} className="text-petroleum font-medium underline break-all block mt-3">{devLink}</a>}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4 mt-4">
              <div>
                <Label>Correo</Label>
                <Input data-testid="forgot-password-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              <Button data-testid="forgot-password-submit-button" type="submit" disabled={loading} className="w-full bg-petroleum rounded-full h-11">
                {loading ? "Enviando..." : "Enviar enlace"}
              </Button>
            </form>
          )}
          <Link to="/login" className="block text-center text-sm text-petroleum font-semibold mt-6">Volver a iniciar sesión</Link>
        </div>
      </div>
    </div>
  );
}
